/**
 * CSRF令牌管理工具
 * 提供統一的方法來獲取、設置和清除CSRF令牌
 */

// 獲取CSRF令牌
export const getCsrfToken = () => {
    // 首先嘗試從cookie獲取CSRF令牌
    const csrfCookie = document.cookie.match(/csrfToken=([^;]+)/)?.[1];
    if (csrfCookie) {
        return csrfCookie;
    }
    // 如果cookie中沒有，嘗試從localStorage獲取（向後兼容）
    return localStorage.getItem('csrfToken');
};

// 設置CSRF令牌
export const setCsrfToken = (token) => {
    if (token) {
        // 將令牌存入localStorage（可選，僅爲向後兼容）
        localStorage.setItem('csrfToken', token);
        
        // 同時更新axios默認頭部
        if (window.axios && window.axios.defaults) {
            window.axios.defaults.headers.common['X-CSRF-Token'] = token;
        }
        // console.log('CSRF令牌已設置:', token.substring(0, 10) + '...');
    }
};

// 清除CSRF令牌
export const clearCsrfToken = () => {
    localStorage.removeItem('csrfToken');
    // 同時清除axios默認頭部
    if (window.axios && window.axios.defaults && window.axios.defaults.headers.common) {
        delete window.axios.defaults.headers.common['X-CSRF-Token'];
    }
    // console.log('CSRF令牌已清除');
};

// 初始化CSRF令牌（從localStorage加載到axios頭部）
export const initCsrfToken = (axiosInstance) => {
    const token = getCsrfToken();
    if (token && axiosInstance && axiosInstance.defaults) {
        axiosInstance.defaults.headers.common['X-CSRF-Token'] = token;
        // console.log('CSRF令牌已初始化:', token.substring(0, 10) + '...');
    } else if (!token) {
        // console.log('未找到CSRF令牌，將嘗試獲取新令牌');
        // 如果沒有令牌，嘗試獲取新令牌
        fetchCsrfToken(axiosInstance);
    }
    return token;
};

// 獲取新的CSRF令牌
export const fetchCsrfToken = async (axiosInstance) => {
    try {
        if (!axiosInstance) {
            console.error('獲取CSRF令牌失敗: axiosInstance未定義');
            return null;
        }

        const response = await axiosInstance.get('/api/csrf-token');
        if (response.data && response.data.csrfToken) {
            setCsrfToken(response.data.csrfToken);
            return response.data.csrfToken;
        }
        return null;
    } catch (error) {
        console.error('獲取CSRF令牌失敗:', error);
        return null;
    }
};

// 添加CSRF令牌到請求配置
export const addCsrfTokenToConfig = (config = {}) => {
    const token = getCsrfToken();
    if (token) {
        if (!config.headers) {
            config.headers = {};
        }
        config.headers['X-CSRF-Token'] = token;
        // console.log('已添加CSRF令牌到請求頭:', token.substring(0, 10) + '...');
    } else {
        // console.warn('無法添加CSRF令牌到請求頭: 令牌不存在');
    }
    return config;
}; 